/**
 * Sonner Toast Component
 *
 * ShadCN-compatible toast component wrapper using Sonner library.
 * Provides toast notifications for success, error, and info messages.
 * Import toast function directly from 'sonner' in components that need it.
 */

import { Toaster as SonnerToaster } from "sonner";

type ToasterProps = React.ComponentProps<typeof SonnerToaster>;

/**
 * Toaster component - renders at the root of the application
 * to display toast notifications.
 */
export function Toaster({ ...props }: ToasterProps) {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          error:
            "group-[.toaster]:bg-destructive group-[.toaster]:text-destructive-foreground group-[.toaster]:border-destructive",
          success:
            "group-[.toaster]:bg-green-50 dark:bg-green-950 group-[.toaster]:text-green-900 dark:text-green-100 group-[.toaster]:border-green-200 dark:border-green-800",
        },
      }}
      {...props}
    />
  );
}
